module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-003"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("JUSTIFICATION BY FAITH"), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Romans+1:14-17&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("ROMANS 1:14-17")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" Paul’s enthusiasm for the gospel was infectious and his desire to go to Rome strategic, for if the head (capital) of the world were converted, the members of the body (the provinces) would surely follow suit. To pagans, the gospel of a crucified Christ seemed to be madness, but Paul was not ashamed of it, for his message was one not merely of words but of the power to change lives. In the divine plan the Jews were granted a certain priority, but the salvation of the Gentiles was in no sense inferior to theirs. In Christ all human barriers and divisions are overturned, so that God’s power may be made plain to everyone. Justification by faith alone is the heart of the Christian gospel, and the Fathers were well aware of this. Centuries before Martin Luther was to make Romans 1:17 the cornerstone of his reformation, they were clearly proclaiming God’s free gift to all who believe, whatever their background or previous spiritual history may have been.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-023"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:14 ")]), _vm._v("An Obligation to All Nations")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEAKING IN THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONGUES OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIONS.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("We must now ask in what sense the apostle is under obligation to Greeks and barbarians, to the wise and to the foolish. What has he received from them that he should be indebted to them? I infer that he is a debtor to the different nations because by the grace of the Holy Spirit he has received the gift of being able to speak in the tongues of all nations, as he himself says: “I speak in tongues more than you all.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN222",
      "id": "ap_NFIN222-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Given that a man receives the gift of tongues not for himself but for the benefit of those to whom he is called to preach, Paul incurs an obligation to all those whose language he has received as a gift from God. He has incurred an obligation to the wise in that he has received the wisdom hidden in the mystery, which he is to speak to the perfect and to the wise. But how is he indebted to the foolish? In that he has received the grace of patience and longsuffering, for it is the height of patience to be able to endure the furor of the foolish. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMEN")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN223",
      "id": "ap_NFIN223-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURING ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSECUTION. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("We can see how in a short time this religion has grown up, making progress through the persecution and death of its adherents and through their endurance of the confiscation of their property and every kind of torture. And this is particularly miraculous, since its teachers are themselves neither very skillful nor very numerous. But in spite of everything, the Word is now preached in all the world, so that “Greeks and barbarians, wise and foolish” now adopt the Christian faith. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINCIPLES 4.1.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN224",
      "id": "ap_NFIN224-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REACHING TO ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL, ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEKS AND ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON-")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEKS. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Paul says that he is under obligation to those whom he names, because he was sent for the purpose of preaching to everyone. For this reason he states that they are all under obligation to believe in God the Creator, from whom and through whom are all things, for obligation and honor form part of the salvation of the believer. He wrote "), _c('i', [_vm._v("Greeks")]), _vm._v(" instead of "), _c('i', [_vm._v("Gentiles,")]), _vm._v("” but this includes those who are called Romans, whether by birth or by adoption, and barbarians, who are those who are not Romans, whose race is inimical, and who are not Gentiles. He speaks of those who are wise, because they are learned in worldly sciences and are called wise in the world whether they are stargazers, geometers, mathematicians, grammarians, orators or musicians. Paul shows that none of these things is of any advantage, nor are these people truly wise, unless they believe in Christ. He calls them fools, because in their simplicity they lack knowledge of spiritual things. He testifies that he has been sent to preach to them all. But he says nothing about the Jews, because he is the teacher of the Gentiles."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN225",
      "id": "ap_NFIN225-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" And this is why he says that he is under obligation, because he has accepted this teaching in order to pass it on, and in passing it on, to acquire it himself. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN226",
      "id": "ap_NFIN226-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul also said this when he was writing to the Corinthians,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN227",
      "id": "ap_NFIN227-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" in order to ascribe everything to God. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN228",
      "id": "ap_NFIN228-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-024"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:15 ")]), _vm._v("Eagerness to Preach the Gospel")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGER TO ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPART ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Paul understood himself to be sent to preach to all nations. Yet he was especially eager to impart the gospel of the grace of God to the Romans, the capital and seat of the empire. For it would be to the benefit and peace of the members if the head were not uncertain. Therefore he opts for the peace of the Romans, that Satan might not get too involved with them, and that he might have even richer fruits of his labor. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN229",
      "id": "ap_NFIN229-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMPTATIONS ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HICK AS ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWFLAKES. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("What a noble soul was Paul! Having taken on himself a task full of such great danger, a voyage across the sea, temptations, plottings, risings—for it was likely that one who was going to address so great a city, which was under the tyranny of ungodliness, should undergo temptations thick as snowflakes. He lost his life in this way, cut down by a tyrant. Yet still he was ready to undergo great troubles. In fact he was enthusiastic even in travail, even as one in haste. He was in a constant state of preparation. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN230",
      "id": "ap_NFIN230-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-025"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:16 ")]), _vm._v("The Power of God for Salvation")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO TO THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Many attacks were made on the gospel when it was first preached, but Paul learned patience from the prophets who said: “Fear not the reproach of men, and be not dismayed at their revilings.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN231",
      "id": "ap_NFIN231-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" He knew that he should preach the gospel, “not in plausible words of human wisdom but in the "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("power of the Spirit.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN232",
      "id": "ap_NFIN232-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Therefore, defining what the gospel is, he proclaims: “It is the power of God for salvation to everyone who has faith, to the Jew first and also to the Greek.” When he says the power of God for salvation he implies that there is another power of God which is not for salvation but for damnation. It may be that it is because of these different powers that right and left are distinguished in God, so that the power for salvation would be identified with the right, and the power by which he condemns would be identified with the left."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN233",
      "id": "ap_NFIN233-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN234",
      "id": "ap_NFIN234-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWER OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("For power backed up the teaching of the apostles, so that if what they preached seemed incredible, signs and wonders performed by the apostles were a testimony that they should not be ashamed of what was said to them, because there was so much power in it. For there is no doubt that words must give way before power. Insofar as the Romans’ preaching was not backed up by signs, it was without the power of God. Paul is not ashamed of the gospel of God, but the implication is that some whom he is addressing may be ashamed of it. Perhaps what had been handed on to them had come into disrepute, because it had never been confirmed by any testimony and hence had become loosened from apostolic teaching. It is the power of God which calls persons to faith and which gives salvation to all who believe, because it remits sins and justifies, so that one who has been marked with the mystery of the cross cannot be bound by the second death. For the preaching of the cross of Christ is a sign that death has been expelled, as the apostle John says: “The reason the Son of God appeared was to destroy the works of the devil.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN235",
      "id": "ap_NFIN235-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Thus no believer is bound by death, since he has a sign that death has been conquered.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“To the Jew first and also to the Greek.” This means to him who is of the race of Abraham and to him who is from the Gentiles. By "), _c('i', [_vm._v("Greek")]), _vm._v(" Paul means Gentile, and by "), _c('i', [_vm._v("Jew")]), _vm._v(" he means a descendant of Abraham. For these began to be called Jews only in the time of Judas Maccabaeus, who in a time of destruction resisted the sacrileges of the Gentiles and by trusting in God rallied the nation and defended his people. He was of the sons of Aaron. Therefore, although Paul puts the Jews first because of their ancestors, nevertheless he says that they must also accept the gift of the gospel in the same way as the Gentiles. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN236",
      "id": "ap_NFIN236-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NASHAMED OF THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSS. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POLLINARIS OF ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AODICEA: ")]), _vm._v("Paul says that even if, in the very largest of cities, the preacher of the cross of Christ will be mocked by the ignorant, he is not to be ashamed. For if the Son of God bore the shame of the cross on our behalf, how could it not be out of place for us to be ashamed at the Lord’s suffering for us? P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN237",
      "id": "ap_NFIN237-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORYING IN THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSS. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul says that he is “not ashamed,” which is not what we usually say of things as glorious as the gospel. Why does he speak like this, when he exults over the gospel even more than he does over heaven? In writing to the Galatians he said: “God forbid that I should glory, except in the cross of our Lord Jesus Christ.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN238",
      "id": "ap_NFIN238-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" How is it then that in this instance he does not even get as far as glory but says only that he is not ashamed? The Romans were most anxious about the things of the world, because of their riches, their empire, their victories, and they thought that their emperors were equal to the gods. . . . While they were so puffed up, Paul was going to preach Jesus, the carpenter’s son who was brought up in Judea, in the house of a lower-class woman, who had no bodyguards, who was not surrounded by wealth, but who died as a criminal among thieves and endured many other inglorious afflictions. Since it was likely that the Romans were pretending that they did not know any of these unspeakable things, Paul "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("understates that he is not ashamed, in order to teach them not to be ashamed of Christ either. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN239",
      "id": "ap_NFIN239-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENSURING THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGANS. ")])]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("This is subtly intended to censure the pagans who, although they do not hesitate to believe that their god Jupiter turned himself into irrational animals and inanimate gold all for the sake of his monstrous lust, think that we Christians should be ashamed to believe that our Lord was crucified in the flesh he assumed, in order to save his image. . . . At the same time Paul is also bearing in mind those heretics who think that the crucifixion is something unworthy of God, not realizing that nothing is more fitting for the Creator than to care for the salvation of his creatures, particularly as he could not suffer any loss to his own nature, which is not subject to corruption. There is no power greater than the one which overcame death and restored to man the life he had lost,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN240",
      "id": "ap_NFIN240-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" even if this seems like weakness to an unbeliever. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN241",
      "id": "ap_NFIN241-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SHAMED. ")])]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNADIUS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTINOPLE: ")]), _vm._v("Those who objected to the Christian gospel ridiculed it, mocking it because of its absurdity. For there is nothing more ridiculous than the word of someone who preaches that the Son of God was born and brought up by Jews, who rejects neither the cross nor death, who says moreover not only that Christ rose from the dead but that he ascended to heaven as Lord of all, that he will raise everyone else from the dead, and other things the apostles preached. The pagans mocked these things and ridiculed them, thinking that they would make the apostles shut up. Therefore St. Paul, feeling obliged to reply to this opinion of the apostles, began his teaching thus: “I am not ashamed of the gospel.” P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN242",
      "id": "ap_NFIN242-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-026"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('i', [_vm._v("1:17 ")]), _vm._v("God’s Righteousness Revealed Through Faith")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDIVIDUAL AND ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORPORATE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTULLIAN: ")]), _vm._v("Where three people are gathered together, there is a church, even if all three are laypersons."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN243",
      "id": "ap_NFIN243-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" For each individual lives by his own faith. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XHORTATION TO ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HASTITY 7.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN244",
      "id": "ap_NFIN244-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH FOR ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("The righteousness of God is revealed in the gospel in that no one is excluded from salvation, whether he be a Jew, a Greek or a barbarian. For the Savior says to everyone equally: “Come to me, all who labor and are heavy laden.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN245",
      "id": "ap_NFIN245-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Concerning “through faith for faith,” we have already said that the first people were in the faith, because they believed God and Moses his servant, from which faith they have now gone over to the faith of the gospel. The quotation from Habakkuk"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN246",
      "id": "ap_NFIN246-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" means either that the one who lives in the law will also believe the gospel or that the one who believes the gospel will also believe the law and the prophets. For one of these does not have the fullness of life without the other. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN247",
      "id": "ap_NFIN247-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECURE IN THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISE. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPRIAN: ")]), _vm._v("If you are a just man and live by faith, if you truly believe in God, why do you, who are destined to be with Christ and secure in the promise of the Lord, not rejoice that you are called to Christ and be glad that you are free from the devil? T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATISE ON ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTALITY 3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN248",
      "id": "ap_NFIN248-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTEOUSNESS OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVEALED. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Paul says this because the righteousness of God is revealed in the one who believes, whether Jew or Greek. He calls it “the righteousness of God” because God freely justifies the ungodly by faith, without the works of the law, just as he says elsewhere: “That I may be found in him, not having a righteousness of my own, based on law, but that which is through "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("faith in Christ, the righteousness from God that depends on faith.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN249",
      "id": "ap_NFIN249-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" He says that this same righteousness is revealed in the gospel when God grants faith to man, through which he may be justified.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The truth and righteousness of God are revealed in this, when a man believes and confesses. The righteousness is of God because what he promised, he gave. Therefore, whoever believes that he has received what God promised through his prophets proves that God is just and is a witness of his righteousness.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Through faith for faith.” What does this mean, except that the faith of God is in him because he promised, and the faith of man is in him because he believes the one who promises, so that through the faith of the God who promises the righteousness of God might be revealed in the faith of the man who believes? For to the believer God appears to be just, but to the unbeliever he appears to be unjust. Anyone who does not believe that God has given what he promised denies that God is truthful. This is said against the Jews, who deny that Christ is the one whom God promised.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“As it is written: ‘He who through faith is righteous shall live.’ ” Paul now moves over to the example of the prophet Habakkuk"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN250",
      "id": "ap_NFIN250-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" in order to declare that in the past it was revealed that a just man lives by faith and not by the law, i.e., that a man is not justified before God by the law but by faith. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN251",
      "id": "ap_NFIN251-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW AND ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURE. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CACIUS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESAREA: ")]), _vm._v("The righteousness of God is revealed in . . . the believer. Paul says that the revelation of righteousness is the approbation of those who do right. Thus he is able to say likewise that wrath is revealed toward those who do the opposite. The Jew has been brought from the faith of the appointed law to the faith which is through Christ and the Gentile from the faith of nature to the same faith in Jesus Christ. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN252",
      "id": "ap_NFIN252-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POLLINARIS OF ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AODICEA: ")]), _vm._v("In place of righteousness by works, which is neither sincere nor life-giving, Paul praised life through faith. The prophet said: “through faith for faith.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN253",
      "id": "ap_NFIN253-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" “If you had believed in Moses,” said Jesus, “you would have believed in me also.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN254",
      "id": "ap_NFIN254-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN255",
      "id": "ap_NFIN255-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTEOUSNESS ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URS. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Whoever has become righteous through faith will live, not just in this life but in the one to come as well. Paul does not merely hint at this but adds something else along with it, viz., that such a life will be bright and glorious. For since it is possible to be saved yet still be ashamed (as, for example, criminals whose crimes have been remitted by imperial clemency), Paul adds “righteousness” here so that no one may think like this about salvation. This righteousness is not ours but belongs to God, and in saying this Paul hints to us that it is abundantly available and easy to obtain. For we do not get it by toil and labor but by believing. Then, since his statement does not seem credible, if the adulterer and homosexual, the graverobber and the magician are not only to be suddenly set free from punishment but to be made righteous, and righteous with the righteousness of God, Paul backs up his assertion from the Old Testament."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN256",
      "id": "ap_NFIN256-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" . . . He sends the hearer back to the dispensations of God which took place in the Old Testament . . . showing that both the righteous and the sinners were justified by faith even then.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For since what God gives transcends reason, it is only reasonable that we need faith to understand it. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN257",
      "id": "ap_NFIN257-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMING TO THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL FROM THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW. ")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v("[")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEUDO-]")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTIUS: ")]), _vm._v("Paul shows that faith may be strengthened in any one through preaching. The first faith, in the law, was to believe in God; the second faith is to believe that Christ is "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("his only begotten Son.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("“Through faith for faith” therefore means to come to the gospel from the law and to believe that both Old and New Testaments hold that both the Father and Christ are God. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER OF ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T. ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN258",
      "id": "ap_NFIN258-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UST ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HALL ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE BY ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE: ")]), _vm._v("It is right for you, my son, to have begun with the law and to have been confirmed in the gospel, from faith to faith, as it is written: “The just shall live by faith.” L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 47.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN259",
      "id": "ap_NFIN259-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("What is now the church, prior to the appearance of what will be, lives in toils and afflictions, and in her the just live by faith. Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UESTIONS 81.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN260",
      "id": "ap_NFIN260-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("He who claims to be just without faith is a liar. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMONS FOR THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAST OF THE ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIVITY, ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 189.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN261",
      "id": "ap_NFIN261-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTEOUSNESS BY ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HICH THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITHFUL ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UST. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("This righteousness is the grace of the New Testament, by which the faithful are just as long as they live by faith, until by the perfection of righteousness they are brought to the face-to-face vision, as they are also brought to the immortality of the body itself, by the perfection of salvation. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT AND THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 18.11.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN262",
      "id": "ap_NFIN262-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTEOUSNESS ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVEALED TO ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH. ")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("The righteousness of God is not revealed to everyone but only to those with the eyes of faith. For the holy apostle teaches us that God foresaw this for us from the beginning and predicted it through the prophets, and even before the prophets, had it hidden in his secret will.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Paul quoted Habakkuk for the benefit of the Jews, because he wanted to teach them not to cling to the provisions of the law but to follow the prophets. For many centuries before they had predicted that one day there would be salvation by faith alone.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Then departing from his admonition to the Jews, he accuses everyone else of having brazenly departed from the natural law which the Creator had placed in them."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN263",
      "id": "ap_NFIN263-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" For when God made them, he did not allow them to live like beasts but honored them with reason and gave them the ability to know the difference between good and evil. Those who lived righteous lives before the time of Moses confirm this by their witness. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN264",
      "id": "ap_NFIN264-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPRISE. ")])]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNADIUS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANTINOPLE: ")]), _vm._v("What is the overall meaning of the above? It is that our gospel is very great and truly marvelous if you pay careful attention to its power. For through faith in Christ all are saved, those whom the natural law has enlightened and those who follow the written law which was added to it. For when someone is informed about the resurrection from the dead, he learns that he too may share in this by obeying the gospel according to the design of the Savior. And this, says Paul, God had in ancient times announced through Habakkuk the prophet when he said: “The righteous shall live through faith.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN265",
      "id": "ap_NFIN265-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN266",
      "id": "ap_NFIN266-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098def88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap3.vue
// module id = 87
// module chunks = 0